import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  align: {
    type: 'string',
    default: 'full',
  },
  title: {
    type: 'string',
    default: '',
  },
  text: {
    type: 'string',
    default:
      'A Sumicity, dentro das determinações legais e normativas aplicáveis, poderá suspender ou cancelar, imediatamente, os benefícios desta oferta, caso constate utilização fraudulenta e/ou indevida dos mesmos. Para mais informações, consulte o regulamento. <a href="https://www.sumicity.com.br/wp-content/uploads/2022/08/Termos-de-Uso-Site_VTI_2022-08-12-002.pdf" data-type="URL" data-id="https://www.sumicity.com.br/wp-content/uploads/2022/08/Termos-de-Uso-Site_VTI_2022-08-12-002.pdf" target="_blank" rel="noreferrer noopener"><mark style="background-color:rgba(0, 0, 0, 0)" class="has-inline-color has-vivid-cyan-blue-color" data-rich-text-format-boundary="true">Termo de uso e adesão a prestação de serviços.</mark></a> ',
  },
  colorTitle: {
    type: 'string',
    default: 'color-grey-dark',
  },
  color: {
    type: 'string',
    default: 'color-black',
  },
  background: {
    type: 'string',
    default: 'white',
  },
  padding: {
    type: 'string',
    default: 'none',
  },
  ...Common,
};
